import { getAuthToken } from '../utils/authSession';
import { getAcceptLanguage } from '../utils/acceptLanguage';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.dr-bardawam.com/api/v1';
const AUTH_API_BASE = process.env.REACT_APP_AUTH_API_URL || 'https://api.dr-bardawam.com/api';

async function buildHeaders(extraHeaders = {}) {
  const token = await getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Accept-Language': getAcceptLanguage(),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extraHeaders,
  };
}

export async function apiFetch(path, options = {}) {
  const url = `${API_BASE}${path}`;
  return fetch(url, {
    ...options,
    headers: await buildHeaders(options.headers),
  });
}

export async function authFetch(path, options = {}) {
  const url = `${AUTH_API_BASE}${path}`;
  return fetch(url, {
    ...options,
    headers: await buildHeaders(options.headers),
  });
}
